/**
 * ASport's own contact details, defined once so a change is one edit.
 *
 * `SUPPORT_EMAIL` is also the address our emails are sent **from** (see `EmailService.SENDER` in
 * `event-api`) — the two must stay the same, because we tell people to search their mailbox for it
 * when a message does not arrive.
 */
export const SUPPORT_EMAIL = 'info@asport.lv'
